import { DateTime } from 'luxon';
import { Link } from 'react-router-dom';

interface Props {}

export const Footer = ({}: Props) => {
  return (
    <footer className="mt-auto border-t">
      <div className="container flex flex-col sm:flex-row items-center justify-between gap-4 py-4">
        <p className="text-sm text-muted-foreground">© {DateTime.now().year} Liquid Budget. All rights reserved.</p>

        <nav className="flex gap-4">
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">
            Home
          </Link>
          <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground">
            Terms
          </Link>
          <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-foreground">
            Privacy Policy
          </Link>
          <div className="text-sm text-muted-foreground hover:text-foreground">info@liquidbudget.com</div>
        </nav>
      </div>
    </footer>
  );
};
